import React, { useEffect, useState } from "react";
import axios from "axios";
import { useDispatch } from 'react-redux';
import {updateUser} from '../../actions/UserActions';
import { useSelector } from 'react-redux';


function Achievement() {
  const user = JSON.parse(localStorage.getItem("user"));
  const dispatch = useDispatch();
  const userData = useSelector(state => state.User);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get('https://splithub-dev.salmonocean-218390b4.centralindia.azurecontainerapps.io/getUser', {
          headers: {
            Authorization: `Bearer ${user?.idToken }`
          }
        });
        dispatch(updateUser(response.data));
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);
  const color= userData?.totalDebt < 0 ? "bg-red-600" : "bg-green-600"
  
  return (
    <>
    {userData && typeof userData?.totalDebt !== 'undefined'?<>
    <div className={`widgetCard relative px-4 py-4 text-center flex-col justify-between ${color} text-slate-50 md:flex md:justify-center md:w-auto`}>
  <div className="font-semibold m-auto">
    <span className="text-lg lg:text">
      {userData && typeof userData.totalDebt !== 'undefined' ? `₹${userData?.totalDebt}` : 'N/A'}
      <span className="text-sm block">
        Your Balance
      </span>
    </span>
  </div>
</div></>:<></>}
   

  </>
  
  );
}

export default Achievement;
